export default __webpack_public_path__ + "static/media/GreyRectangleTopEllipse.9f584123.svg";